import { DataGridViewType } from '../model/types';

export const isTreeDataGrid = (viewType: DataGridViewType): boolean => {
  return viewType === DataGridViewType.treeDataGrid;
};
